export function newsletter_signup_call(form, section, paintBorder) {
	var emailVal = form.find('.email-control').val();
	var nlVal = form.find('.post-newsletter').val();
	var button = form.find('.send-contact');
	var privacyCheck = form.find('.check-privacy input');
	var privacyData = '';
	var nameVal = form.find('.name-control').val();
	var dateVal = form.find('.date-control').val();
	var umzugVal = form.find('.umzug-newsletter').val();
	var sourceVal = form.find('.umzug-source').val();
	paintBorder = paintBorder ?? umzugVal === 'ratgeber';

	if (privacyCheck.is(':checked')) {
		privacyData = privacyCheck.val();
	}

	jQuery.ajax({
		url: form.attr('action'),
		type: 'POST',
		data: {
			action: 'confirm_contact_to_mailjet',
			contact: emailVal,
			name: nameVal,
			date: dateVal,
			newsletter: nlVal,
			quelle: sourceVal,
			umzug: umzugVal,
			privacy: privacyData
		},
		dataType: 'json',
		beforeSend: function () {
			button.addClass('loading');
		},
		error: function () {
			button.removeClass('loading');
		},
		success: function (data) {
			if (!data.success) {
				button.removeClass('loading');
				jQuery('.help-block').remove();

				if (data.errors) {
					section.addClass('has-error'); // add the error class to show red input
					jQuery.map(data.errors, function (output) {
						section.append('<div class="help-block">' + output + '</div>'); // add the actual error message under our input
					});
				}
			} else {
				jQuery('.help-block').remove();
				form.remove();
				section.append('<div class="alert alert-success"><strong>' + data.head + '</strong><br>' + data.message + '</div>');

				if (paintBorder) {
					jQuery('.alert.alert-success').css({ 'border': '1px solid rgb(41, 204, 240)', 'padding': '20px 30px' })
				}
			}
		}
	});

	return false;
}
